import { metrics } from "@/lib/data";

const Metrics = () => {
    return (
        <section className='py-12 border-y border-border/20 bg-background/50 backdrop-blur-sm relative z-10 overflow-hidden'>
            <div className='max-w-[100vw] mx-auto relative'>
                {/* Masking gradients for smooth fading edges */}
                <div className="pointer-events-none absolute inset-y-0 mt-16 left-0 w-1/6 md:w-1/4 bg-gradient-to-r from-background to-transparent z-20"></div>
                <div className="pointer-events-none absolute inset-y-0 mt-16 right-0 w-1/6 md:w-1/4 bg-gradient-to-l from-background to-transparent z-20"></div>

                <div className='flex animate-marquee py-4'>
                    {[...metrics, ...metrics, ...metrics].map((metric, index) => {
                        return (
                            <div
                                key={`${metric.label}-${index}`}
                                className='group flex flex-col items-center justify-center transition-all duration-300 cursor-default mx-8 md:mx-12 min-w-[80px]'
                            >
                                <div className="text-4xl lg:text-5xl font-bold text-primary mb-1">
                                    {metric.value}
                                </div>
                                <span className='text-xs font-bold text-muted-foreground uppercase tracking-widest whitespace-nowrap'>
                                    {metric.label}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Metrics;